/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {VersionCellValueModel} from './version-cell-value.model';
import {ActivationDateCellValueModel} from './activationDate-cell-value.model';
import {SettingStatusEnum} from '../../../../api/ms-settings/business/schema/v1/contracts/setting-status.enum';
import {StatusCellValueModel} from './status-cell-value.model';
import {NotesCellValueModel} from './notes-cell-value.model';
import {UserBaseModel} from '../../../../api/ms-settings/business/schema/v1/contracts/user-base.model';

/**
 * Version Pipe on column table
 */
export function versionPipe(cellValue: VersionCellValueModel): string {
    let displayValue = '-';
    if (cellValue != null) {
        if (cellValue.status != null && cellValue.lastChangeDateTime != null && cellValue.status.code === SettingStatusEnum.DRAFT) {
            displayValue = `${cellValue.status.description} ${cellValue.lastChangeDateTime}`;
        } else {
            displayValue = `${cellValue.version}`;
        }
    }
    return displayValue;
}

/**
 * Version Pipe on header title in an expandable line
 */
export function versionTitleOnExpandableLinePipe(cellValue: VersionCellValueModel): string {
    let displayValue = '-';
    if (cellValue != null) {
        if (cellValue.version != null && cellValue.status.code !== SettingStatusEnum.DRAFT) {
            displayValue = `Version ${cellValue.version}`;
        } else {
            displayValue = `${cellValue.status.description} ${cellValue.lastChangeDateTime}`;
        }
    }
    return displayValue;
}

/**
 * Status Pipe on column table
 */
export function statusPipe(cellValue: StatusCellValueModel): string {
    let displayValue = '-';
    if (cellValue != null) {
        if (cellValue.description != null) {
            displayValue = `${cellValue.description}`;
        }
    }
    return displayValue;
}

/**
 * Status Pipe on header in an expandable line
 */
export function statusTitleOnExpandableLine(cellValue: StatusCellValueModel): string {
    let displayValue = '-';
    if (cellValue != null) {
        if (cellValue.code !== SettingStatusEnum.DRAFT) {
            displayValue = `${cellValue.code}`;
        } else {
            return;
        }
    }
    return displayValue;
}

/**
 * Activation Date Pipe on column table
 */
export function activationDatePipe(cellValue: ActivationDateCellValueModel): string {
    let displayValue = '-';
    if (cellValue != null) {
        if (cellValue.lastChangeDateTime != null && cellValue.status.code !== SettingStatusEnum.DRAFT) {
            displayValue = `${cellValue.lastChangeDateTime}`;
        }
    }
    return displayValue;
}

/**
 * Notes Pipe on column table
 */
export function notesPipe(cellValue: NotesCellValueModel): string {
    let displayValue = '-';
    if (cellValue != null && cellValue.notes != null) {
        displayValue = `${cellValue.notes}`;
    }
    return displayValue;
}

/**
 * Username Pipe on column table
 */
export function updatedByPipe(cellValue: UserBaseModel): string {
    let displayValue = '-';

    if (cellValue != null) {

        if (cellValue.username != null) {
            displayValue = cellValue.username;

            if (cellValue.email != null) {
                displayValue = `${cellValue.email} (${cellValue.username})`;
            }
        }
    }
    return displayValue;
}
